import React from 'react'

import * as l from '../../../utils/localization/format'
import SearchInput from '../SearchInput'

import { SelectSearchProps } from './interfaces'

export const SelectSearch = ({
  query,
  onChange,
  activeItemId,
  onKeydown,
  searchLabel,
}: SelectSearchProps) => {
  return (
    <SearchInput
      ariaLabel={l.translate('Search')}
      className="p-x-xs p-y-xs b-b"
      placeholder={l.translate('Search') || searchLabel}
      onChange={onChange}
      value={query}
      aria-activedescendant={activeItemId}
      onKeyDown={onKeydown}
    />
  )
}
